import { Component } from "@stencil/core";
import { setBackTeaserData } from "./persist";

/**
 * This component saves the current page in a cookie
 * to enable the separate ux-iws-back-teaser to navigate back to it.
 */
@Component({
    tag: "ux-iws-back-teaser-save",
    shadow: true,
})
export class BackTeaserSave {
    componentWillLoad() {
        document.addEventListener("visibilitychange", this.saveBackTeaser);
    }

    private saveBackTeaser = () => {
        if (document.visibilityState !== "hidden") return;
        setBackTeaserData({
            title: document.title,
            href: location.href,
        });
    };
}
